<template>
  <div class="article-detail">
    <h3>发票说明：</h3>
    <p>1）如您为【一般纳税人】，则必须开具增值税专用发票。</p>
    <p>2）如您为【小规模纳税人】，也请至当地主管税务局代开增值税专用发票。</p>
    <p>
      发票上请加盖您公司的发票专用章，请寄送发票联和抵扣联，发票邮寄地址请联系聚推客联盟客服索取（不接收快递到付）。
    </p>

    <h3>发票信息</h3>
    <p>发票类目：技术服务费</p>
    <p>公司名称：广州言成科技有限公司</p>
    <p>发票税号：91440101MA5CLGXL71</p>
    <p>公司地址：广州市番禺区小谷围街道青蓝街28号1栋502（502-6）</p>
    <p>注册电话：15802455955</p>
    <p>开户银行：中国银行广州番禺大学城支行</p>
    <p>银行帐号：676971338435</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
h3 {
  font-size: 16px;
  font-weight: 700;
}
p {
  margin: 10px 0;
  font-size: 16px;
}

a {
  font-size: 16px;
  color: #4080ff;

  &:hover {
    text-decoration: underline;
  }
}

img {
  max-width: 100%;
}
</style>
